"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var JSFAjaxJQueryAdapter = (function () {
    function JSFAjaxJQueryAdapter() {
        var w = window;
        var jQueryToUse = w.jQuery !== undefined ? w.jQuery : (w.$ !== undefined ? w.$ : $);
        document.addEventListener('jsfAjaxEvent', function (evt) {
            var data = evt.detail;
            var fireType = data.fireType;
            jQueryToUse(evt.target).trigger('jsfAjax' + fireType.charAt(0).toUpperCase() + fireType.substring(1), data);
        });
    }
    JSFAjaxJQueryAdapter.init = function () {
        if (JSFAjaxJQueryAdapter.instance === undefined) {
            JSFAjaxJQueryAdapter.instance = new JSFAjaxJQueryAdapter();
        }
    };
    return JSFAjaxJQueryAdapter;
}());
exports.default = JSFAjaxJQueryAdapter;
